import React from "react";
import type { RouteComponentProps } from "react-router-dom";

import type { Task, TaskType } from "@/core/types";

import { ConsentRouter } from "./ConsentRouter";
import { UploadPhotoID } from "./UploadPhotoID";

type LoginTasksProps = {
  onTaskCompleted: (task: Task) => void;
  onTaskSkipped: (task: Task) => void;
  task: Task;
} & RouteComponentProps<{ task_name: TaskType }>;

export function LogInTasksRouter({ match, onTaskCompleted, onTaskSkipped, task }: LoginTasksProps) {
  const taskType = match.params.task_name;

  switch (taskType) {
    case "UPDATED_CHILD_CONSENT":
    case "UPDATED_CONSENT_REQUIRED":
    case "UPDATED_POLICIES":
      return <ConsentRouter onTaskCompleted={onTaskCompleted} task={task} />;

    case "ID_DOCUMENT_UPLOAD":
      return (
        <UploadPhotoID
          onComplete={() => onTaskCompleted(task)}
          onSkip={() => onTaskSkipped(task)}
        />
      );

    default:
      return null;
  }
}
